import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'uploadedValidProspects',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Uploaded Valid Prospects',
  },
}

const keys = {
  statKey: 'uploaded_valid_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const uploadedValidProspects = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { uploadedValidProspects }
